// Countdown timer
  let end = new Date(); end.setHours(end.getHours()+23, end.getMinutes()+59);
  function tick() {
    let diff = Math.max(0, end - new Date());
    let h = Math.floor(diff/3600000); diff %= 3600000;
    let m = Math.floor(diff/60000);   diff %= 60000;
    let s = Math.floor(diff/1000);
    document.getElementById('h').textContent = String(h).padStart(2,'0');
    document.getElementById('m').textContent = String(m).padStart(2,'0');
    document.getElementById('s').textContent = String(s).padStart(2,'0');
  }
  tick(); setInterval(tick, 1000);

  // Accordion
  function toggleAcc(t) {
    const b = t.nextElementSibling, open = t.classList.contains('open');
    document.querySelectorAll('.accordion-trigger').forEach(x => { x.classList.remove('open'); x.nextElementSibling.classList.remove('open'); });
    if (!open) { t.classList.add('open'); b.classList.add('open'); }
  }

  // Color selection hero
  function selectColor(dot) {
    document.querySelectorAll('.color-dot').forEach(d => d.classList.remove('active'));
    dot.classList.add('active');
  }

  // Color PDP
  function selectColorPDP(chip, name) {
    document.querySelectorAll('.color-chip').forEach(c => c.classList.remove('active'));
    chip.classList.add('active');
    window.pdpColor = name;
    document.getElementById('color-selected').textContent = name;
  }

  // Thumbs PDP
  document.querySelectorAll('.pdp__thumb').forEach(t => {
    t.addEventListener('click', function() {
      document.querySelectorAll('.pdp__thumb').forEach(x => x.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Qty
  function selectQty(c) {
    document.querySelectorAll('.qty-chip').forEach(x => x.classList.remove('active'));
    c.classList.add('active');
  }

  // Offer
  function selectOffer(c) {
    document.querySelectorAll('.offer-card').forEach(x => x.classList.remove('active'));
    c.classList.add('active');
  }

  // Reviews tabs
  function filterR(t) {
    document.querySelectorAll('.review-tab').forEach(x => x.classList.remove('active'));
    t.classList.add('active');
  }

  // Add to cart
  function addToCartDemo() {
    const btn = document.querySelector('.pdp__cta');
    btn.textContent = '✓ Ajouté au panier !';
    btn.style.background = 'var(--teal)';
    setTimeout(() => { btn.textContent = 'Commander maintenant →'; btn.style.background = ''; }, 2500);
  }

  // Sticky nav shadow
  const navEl = document.querySelector('nav');
  window.addEventListener('scroll', () => {
    navEl.style.boxShadow = window.scrollY > 10 ? '0 4px 24px rgba(13,33,55,.14)' : '';
  });